import React, { useCallback } from 'react';

import { RotationLeftIcon, RotationRightIcon } from '@vlabs/icons';
import { ButtonScrimGroup, ButtonScrimDivider } from '@vlabs/uikit';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton';

type TDegree = 0 | 90 | 180 | 270;
type TDirection = 'cw' | 'ccw';

interface RotateButtonsProps {
  degree?: TDegree;
  onChange?: ((degree: TDegree) => void);
}

export function RotateButtons({
  degree = 0,
  onChange = undefined,
}: RotateButtonsProps): React.JSX.Element {
  const onRotate = useCallback((direction: TDirection): void => {
    const step = direction === 'cw' ? 90 : -90;
    const nextDeg = (((degree + step) % 360) + 360) % 360;
    onChange?.(nextDeg as TDegree);
  }, [degree, onChange]);

  return (
    <ButtonScrimGroup
      onSurface={false}
      size="small"
    >
      <IconButton
        data-testid="rotateClockwiseButton"
        icon={<RotationRightIcon />}
        kind="secondary"
        onClick={() => onRotate('cw')}
      />

      <ButtonScrimDivider />

      <IconButton
        data-testid="rotateCounterclockwiseButton"
        icon={<RotationLeftIcon />}
        kind="secondary"
        onClick={() => onRotate('ccw')}
      />
    </ButtonScrimGroup>
  );
}
